/**
 * Set button to a loading or finished state
 *
 * @since 1.0.0
 */
const menuButton = document.querySelector ( '.js-nav-btn' )
const menuButtonContainer = document.querySelector( '.js-nav-btn-container' )
const menuContainer= document.querySelector ( '.js-nav' )
const bodyWrapper = document.querySelector ( '.js-body-wrapper' )
const menuButtons = document.querySelectorAll ( '.js-page-scroll-button' )
const logo = document.querySelector ( '.js-header' )

let menuActive = false
export default () => {
  if (!bodyWrapper) return
  menuButton.addEventListener ( 'click', () => {
    if( menuActive == false ) {
      openMenu()
    }
    else if ( menuActive == true ) {
      closeMenu()
    }
  }) 
  bodyWrapper.addEventListener ( 'click', () => {
    if( menuActive == true ) {
      closeMenu()
    }
  }) 
  ;[...menuButtons].forEach ( el  => {
    el.addEventListener ( 'click', () => {
      closeMenu()
    })
  })
}

const openMenu = () => {
  menuButtonContainer.classList.add ( 'c-nav__button-container--active' )
  menuContainer.classList.add ( 'c-nav--active' )
  bodyWrapper.classList.add ( 'c-body-wrapper--active' )
  logo.classList.add ( 'c-header__link--active' )
  menuActive = true
}

const closeMenu = () => {
  menuButtonContainer.classList.remove ('c-nav__button-container--active' )
  menuContainer.classList.remove ('c-nav--active' )
  bodyWrapper.classList.remove ('c-body-wrapper--active' )
  logo.classList.remove ( 'c-header__link--active' )
  menuActive = false
}


// WEBPACK FOOTER //
// ./src/js/modules/Menu.js